import React from 'react';
import { CTAButton } from './CTAButton';
export function Footer() {
  return <footer className="bg-brand-brown text-brand-cream pt-14 pb-8 px-4 relative overflow-hidden" data-id="element-102">
      {/* Decorative top border */}
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-brand-gold via-brand-green to-brand-gold" data-id="element-103" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-104">
        <div className="mb-12 bg-white/5 p-8 md:p-10 rounded-3xl border border-white/10 backdrop-blur-sm" data-id="element-105">
          <h2 className="text-3xl md:text-4xl font-black mb-5 font-playfair text-white leading-tight" data-id="element-106">
            ¿Seguís esperando el momento ideal?
          </h2>
          <p className="text-xl text-brand-cream/90 mb-8 font-medium" data-id="element-107">
            El momento ideal es ahora. Por{' '}
            <strong className="text-brand-gold font-black" data-id="element-108">$7.990</strong> tenés
            todo el sistema para empezar hoy.
          </p>

          <CTAButton className="w-full md:w-[80%] text-xl md:text-2xl py-5 bg-brand-green hover:bg-brand-green/90 text-white shadow-[0_10px_30px_rgba(107,143,113,0.3)] hover:shadow-[0_15px_40px_rgba(107,143,113,0.5)] border border-brand-green/50" data-id="element-109">
            EMPEZAR HOY POR $7.990 →
          </CTAButton>

          <div className="mt-5 text-brand-gold text-sm font-bold flex items-center justify-center gap-2 uppercase tracking-widest" data-id="element-110">
            <span className="text-lg" data-id="element-111">⚠</span> Oferta de lanzamiento · Se
            cierra sin previo aviso
          </div>
        </div>

        <div className="border-t border-brand-cream/10 pt-8" data-id="element-112">
          <p className="text-brand-cream/70 text-base font-bold mb-4" data-id="element-113">
            © Mega Pack Jabones Artesanales — Todos los derechos reservados
          </p>
          <div className="flex flex-wrap justify-center gap-6 text-sm text-brand-cream/50 mb-6 font-medium" data-id="element-114">
            <a href="#" className="hover:text-brand-cream transition-colors" data-id="element-115">
              Política de Privacidad
            </a>
            <span className="opacity-30" data-id="element-116">|</span>
            <a href="#" className="hover:text-brand-cream transition-colors" data-id="element-117">
              Términos
            </a>
            <span className="opacity-30" data-id="element-118">|</span>
            <a href="#" className="hover:text-brand-cream transition-colors" data-id="element-119">
              Contacto
            </a>
          </div>
          <p className="text-xs text-brand-cream/30 max-w-3xl mx-auto leading-relaxed text-justify md:text-center" data-id="element-120">
            Los resultados individuales pueden variar. Esta oferta de
            lanzamiento puede finalizar en cualquier momento sin previo aviso.
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </div>
    </footer>;
}